import { UserGuide } from "./userGuide";

export default UserGuide;
